<template>
    <el-dialog class="paper-dialog" v-model="isVisible"  :show-close="false" width="1800" align-center :destroy-on-close="true" @close="close">
      <template #header="{}">
        <div class="my-header">
          <div>{{ $t("smart_OM_model.smart_OM") }}</div>
          <el-icon class="cursor-pointer" @click="close" color="#fff" ><Close /></el-icon>
        </div>
      </template>
     <div class="outside-center">
      <!-- 上 -->
      <div class="d-flex justify-content-between">
        <div class="d-flex flex-column" style="width: 400px;">
          <!-- 智控状态 -->
          <div class="part-card flex-1 align-items-center w-100">
            <Top :name="$t('smart_OM_model.model_status')" :show-switch="true" :switchValue="isRunning" @switchChange="handleRunning" :lineType="'2'"></Top>
            <!-- status-button-close -->
            <div class="status-button">
              <img v-if="isRunning" class="outerAnimation" src="../../../assets/images/dashboard/running_btn.png" alt="">
              <img v-else src="../../../assets/images/dashboard/closed_btn.png" alt="">
            </div>
            <div class="mt-4 mb-4">{{ isRunning?$t("smart_OM_model.start_time"):$t("smart_OM_model.end_time")}} : {{ startEndDate }}</div>
            <div class="mb-2">{{ $t("smart_OM_model.intelligent_total_running_time") }}:  
              <span style="color: #13C56B;">{{ equip_data.id == IS_DEMO_PAPER_MAKING_EP1000_ID?"147":equip_data.uptime }} h</span>
            </div>
          </div>
          <!-- 能效实时监测 -->
          <div class="part-card flex-1 position-relative w-100 justify-content-between">
            <Top :name="$t('smart_OM_model_paper_making.energy_efficiency_realtime_monitoring')" :show-button="false" :lineType="'2'"></Top>
            <div id="polygondom" style="width: 100%;height: calc(100% - 30px);"></div>
            <div class="position-absolute"  style="font-size:12px;bottom: 10px;left: 32%;">{{ $t("smart_OM_model_paper_making.suction_volumetric_flow") }}</div>
          </div>
        </div>
        <!-- 实时监控 -->
        <div class="part-card" style="width: calc(100% - 438px);min-width: 1300px;font-size: 12px;">
          <Top :name="$t('smart_OM_model.real_time_monitoring')" :show-button="false" :buttonName="'Energy Efficiency'" :buttonClick="clickTo" :lineType="'1'"  
          :buttonStyle="{backgroundColor: '#22BBE8',height:'27px',border:'none',fontSize:'14px'}" ></Top>
          <div class="position-relative">
            <!-- 测点名称 -->
            <template v-for="item in configurationDiagramList" :key="item.name">
              <div class="position-absolute d-flex align-items-center" :style="item.pos">
                 <div class="ms-2"> {{ item.name  }} </div>
              </div>
            </template>
            <!-- 测点盒子 -->
            <template v-for="item in measurementsList" :key="item.id">
              <table class="position-absolute meas-table" :style="`min-width: 122px;${item.pos}`">
                <tr v-for="(meas) in item.list" :key="meas.name" :class="[isRunning&&meas.name.includes('MS')&&'blink']">
                  <td style="padding-left: 5px">{{ meas.full_name }}</td>
                  <td>:</td>
                  <td style="padding-left: 3px;padding-right: 3px;min-width: 39px;">{{ meas.value }}</td>
                  <td style="padding-left: 3px;padding-right: 5px;">{{ meas.unit }}</td>
                  <td v-if="meas.isAscShow&&meas.isArrow" style="padding-left: 3px;padding-right: 3px;width: 15px;">
                    <templat v-if="meas.isAscShow&&meas.isArrow">
                      <img v-if="meas.isArrow.includes('equivalent_icon')" :src="meas.isArrow" alt="" style="height:6.17px;width:14.8px;">
                      <img v-else :src="meas.isArrow" alt="" style="width:6.17px;height:14.8px;">
                    </templat>
                  </td>
                </tr>
              </table>
            </template>

            <img style="width: 1240px; height: 560px; margin: 20px;" :src="smartOMPaperMakingSvg" alt="">
          </div>
        </div>
      </div>
      <!-- 下 -->
      <div class="d-flex" style="height: 255px;">
          <!-- 关键指标趋势 -->
          <div class="part-card h-100 flex-1 position-relative" style="padding-bottom: 0px;">
            <SelectsTop :name="$t('smart_OM_model.key_metrics_trend')" 
              :button-name="`${currentSelect.length} ${$t('smart_OM_model.items_selected')}`" 
              :defaultCheckedKeys="default_checked_keys"
              @handleCurrentSelect="handleCurrentSelect" 
              :lineType="'1'"></SelectsTop>
            <div class="fs-14 position-absolute" style="top:20px;right: 100px;">{{ $t("smart_OM_model.last_updated") }}： {{ timestamp||"-"}} </div>
            <div id="miniEcharts" style="width: 100%;height: calc(100% - 21px);"></div>            
          </div>
          <!-- 智能运行日志 -->
          <div class="part-card h-100 flex-1">
            <Top :name="$t('smart_OM_model.model_logs')" :show-button="false" :lineType="'1'"></Top>
            <div class="position-relative flex-1 d-flex align-items-center" >
              <template v-for="(item, index) in modelLog" :key="index">
                <div class="date-box-item-p position-absolute" :style="modelLogPos[index]">
                  {{ item }}
                </div>
              </template>
              <img :src="isRunning?running_icon:true_icon" alt="" :class="['position-absolute',`${isRunning?'running-icon-p':'true-icon-p'}`]">
              <div v-if="isRunning" class="position-absolute d-flex flex-column align-items-center" style="font-size:14px;bottom:13px;right:0px;">
                <div>Target Turbo: 7600</div>
                <div class="d-flex align-items-center justify-content-center" style="width: 207px;">
                  <span class="me-1">Last Command: Add to {{ randomNumber }}</span> 
                  <!-- 上升ascend或下降decline -->
                  <template v-if="randomNumberArrow">
                    <img v-if="randomNumberArrow.includes('equivalent_icon')" :src="randomNumberArrow" alt="" style="height:6.17px;width:14.8px;">
                    <img v-else :src="randomNumberArrow" alt="" style="width:6.17px;height:14.8px;">
                  </template>
                </div>
              </div>
              <img src="../../../assets/images/dashboard/smart_logs_paper_making.svg" alt="">
            </div>            
          </div>
      </div>
     </div>
    </el-dialog>
  </template>
  
  <script>
  import { Close } from '@element-plus/icons-vue';
  import SelectsTop from '@/components/common/SelectsTop.vue';
  import moment from 'moment';
  import { spectrumEcharts4, polygonChart } from "@/utils/chart";
  import { formatNumber } from "@/utils/common.js";
  import { SOCKET_SVC_HOST, IS_DEMO_PAPER_MAKING_EP1000_ID } from "@/config/common.js";
  import { getRawTimeseries } from "@/service/index";
  import qs from "qs";
  import _ from "lodash";
  import { MEASUREMENTS_LIST,MEASUREMENTS_LIST_1 } from "@/components/devices/VSD420-OverAll/measurements.js";

  export default {
    emit:["closeDialog","handleCurrentState"],
    props:{
      visible:{
        type:Boolean,
        default:false,
      }
    },
    data() {
      return {
        IS_DEMO_PAPER_MAKING_EP1000_ID,
        smartOMPaperMakingSvg:require("@/assets/images/dashboard/smart_o_m_paper_making.gif"),//造纸厂
        smartOMNoValveSvg:require("@/assets/images/dashboard/smart_om_no_valve.svg"),//没有阀门的机组图片
        smartOMValveSvg:require("@/assets/images/dashboard/smart_o_m.gif"), //有阀门的机组图片
        valveCloseSvg:require("@/assets/images/dashboard/valve_close.svg"),
        valveOpeningSvg:require("@/assets/images/dashboard/valve_opening.svg"),
        /*模型的运行是周期性（根据算法的定义）的，可能一周或一天运行一次，模型运行达到理想效果时就会停止，然后等待一段时间再去运行下一次*/ 
        isRunning:true, //模型是否运行
        true_icon:require("@/assets/icon-font/true_icon.svg"), //运行完一个周期
        running_icon:require("@/assets/icon-font/running.svg"), //运行当中
        asc_icon:require("@/assets/icon-font/asc_icon.svg"),//上升
        dec_icon:require("@/assets/icon-font/dec_icon.svg"),//下降
        equivalent_icon:require("@/assets/icon-font/equivalent_icon.svg"),//相等
        currentSelect:[],//默认展示前2个测点echart
        default_checked_keys:[],
        randomNumber:150,//随机数
        randomNumberArrow:null,
        timer:null,
        /* 左侧测点 */ 
        leftMeasurementsList:[],
        modelLogPos:[
          'top:45px;right:56px;',
          'bottom:38px;right:180px;',
          'top:50px;left:350px;',
          'bottom:38px;left:206px;',
          'top:50px;left:56px;',
        ],
        modelLog:[],
       /* 组态图测点列表 */
       configurationDiagramList:[
          { is_run: false, name:'pick-up felt',full_name:"pick-up felt", pos:'font-size:14px;left:40px;top:12px'},
          { is_run: false, name:'1st press',full_name:"1st press", pos:'font-size:14px;right:530px;top:238px'},
          { is_run: false, name:'3rd press',full_name:"3rd press", pos:'font-size:14px;top:13px;left:1003px'},
        ],

        /* 
        右侧测点列表
        isAscShow:是否显示升降序符号
        isArrow:箭头
        name:测点名称
        full_name:测点全称
        value:测点值
        unit:测点单位
         */
        measurementsList:[],
        ws_v:{},
        myChart:null,
        retryCount:0, 
        timestamp:'',
        startEndDate:'',//运行的开始时间或结束时间
        shadowIdList:[],

      }
    },
    mounted(){
      this.isRunning = this.$store.state.equipManagement.isRunning
      this.$store.commit( "equipManagement/set_is_running", this.isRunning);

      // log日志逻辑
      let list = JSON.parse(sessionStorage.getItem('modelLogDatePaper-'+this.equip_data.id))||[]
      if(list.length){
         this.modelLog = list
      }else{
        for (var i = 0; i < 5; i++) {
          let date = "2025.04.12";
          if(this.equip_data.id == IS_DEMO_PAPER_MAKING_EP1000_ID){
            date = "2025.12.26"
          }
          if(i>0){
            this.modelLog.push(moment(date).subtract(2*i, 'days').format("YYYY.MM.DD")+' 07:48 AM')
          }else{
            this.modelLog.unshift(moment(date).format("YYYY.MM.DD")+' 07:48 AM') 
          }
        }
      }
      
      this.startEndDate = moment(this.modelLog[0]).format('YYYY-MM-DD HH:mm:ss')
      sessionStorage.setItem('modelLogDatePaper',JSON.stringify(this.modelLog))
      
      //能效实时监控               
      this.$nextTick(() => {
        if (document.getElementById("polygondom")) {
          polygonChart(document.getElementById("polygondom"))
        }
      });
      this.generateRandomNumber() //周期log随机增加数
      this.getHistoryData() //获取历史数据
      this.initWebSocket() //实时数据
    },
    beforeUnmount(){
      if (this.timer) {
        clearInterval(this.timer);
      }
    },
    computed:{
      isVisible(){
        return this.visible;
      },
      equip_data() {
        return _.cloneDeep(this.$store.state.equipManagement.equipData);
      },
      measurements() {
        let measur = []
        let info = _.cloneDeep(this.$store.state.equipManagement.equipData)
        if(info&&info.attributes){
          if(info.attributes.measurements.length){
            let list  = info.attributes.measurements.map(item=>{
              return {equipment_id:info.id, equip_name:info.name,root_sn:info.root_sn, ...item}
            })
            measur = [...list]
          }
          if(info.children){ //机组需要获取子设备测点数据
            info.children.map(item=>{
              if(item.attributes&&item.attributes.measurements){
                let list  = item.attributes.measurements.map(an=>{
                  return {equipment_id:item.id, equip_name:item.name, root_sn:item.root_sn, ...an}
                })
                measur = [...measur, ...list]
              }
            })
          }
        }
        // measur.reverse()//反转
        return measur;
      },
      /* 获取测点组别,获取历史数据 */ 
      measurementsGroup() {
        let measur = {}
        let info = _.cloneDeep(this.$store.state.equipManagement.equipData)

        if(info&&info.attributes){
          measur[info.id] = info.attributes.measurements.map(item=>{
            return {...item,root_sn:info.root_sn}
          })
          if(info.children){ //机组需要获取子设备测点数据
            info.children.map(item=>{
              if(item.attributes&&item.attributes.measurements){
                measur[item.id] = item.attributes.measurements.map(i=>{
                  return {...i, root_sn:item.root_sn}
                })
              }
            })
          }
        }
        return measur;
      },
      totalDuration(){ //造纸厂展示运行时长
        let baseHour = 129
        const baseTime = moment('2025-04-08 00:00:00', 'YYYY-MM-DD HH:mm:ss')
        const now = moment()

        if (now.isBefore(baseTime)) return baseHour

        const hoursPassed = now.diff(baseTime, 'hours')
        return baseHour + hoursPassed;
      },
    },
    watch: { 
      equip_data: {
        handler(newValue) {
          if (newValue) {
            // 造纸演示客户机组设备 EP1000 测点数据展示
            this.measurementsList = newValue.id == IS_DEMO_PAPER_MAKING_EP1000_ID ? MEASUREMENTS_LIST_1 : MEASUREMENTS_LIST;
          }
        },
        immediate: true
      }
    },
    methods:{
      moment,
      close(){
        this.$emit("closeDialog")
      },
      handleRunning(val){
        
        if(!this.isRunning){ //点击之前停运状态
          this.modelLog.pop()
          this.modelLog.unshift(moment().format("YYYY.MM.DD HH:mm A")) 
          this.startEndDate = moment().format('YYYY-MM-DD HH:mm:ss')//运行时间
        }else{//点击之前运行状态
          this.startEndDate = moment().format('YYYY-MM-DD HH:mm:ss')//运行时间
        }
        this.isRunning = val
        sessionStorage.setItem("modelLogDate",JSON.stringify(this.modelLog))

        this.$store.commit( "equipManagement/set_is_running", this.isRunning);
        
      },
      generateRandomNumber() {
        // 使用 setInterval 每隔5秒生成一个100-200的随机数，并存储定时器ID
        this.timer = setInterval(() => {
          let value = Math.floor(Math.random() * 101) + 100;
          if(this.randomNumber>value){
            this.randomNumberArrow = this.dec_icon //下降
          }else if(this.randomNumber == value){
            this.randomNumberArrow = this.equivalent_icon //相等
          }else{
            this.randomNumberArrow = this.asc_icon //上升
          }
          this.randomNumber = value
        }, 5000); // 5000毫秒 = 5秒
      },
      clickTo(){
        //  跳转能耗分析页面/equipment-detail?index=1&equip_id=5ac59500-70e3-11ef-a113-4bd278884fe5&type=energyConsumptionAnalysis&isShowEcharts=false
        this.$router.push({
          path:'/equipment-detail',
          query:{
            index:1,
            equip_id:'5ac59500-70e3-11ef-a113-4bd278884fe5',
            type:'energyConsumptionAnalysis',
            isShowEcharts:false
          }
        })
      },
      /* 更新展示测点 */ 
      handleCurrentSelect(indexs){
        this.currentSelect = indexs
        
        this.leftMeasurementsList.forEach((i,index)=>{
          if(this.currentSelect.includes(`${i.root_sn}-${i.measurement_id}`)){
            i.is_checked = true
          }else{
            i.is_checked = false
          }
        })

        if(this.currentSelect.length == 0){
          this.updateChart([],false) //更新图表
        }else{
          this.updateChart(this.leftMeasurementsList,false) //只更新series数据
        }
      },
      /* 获取历史测点数据 */
      getHistoryData(){
        var column = [];
        let count = 0; // 计数变量
        this.measurements.forEach((item,index)=>{
          if (this.ws_v[item.equipment_id]) {
            this.ws_v[item.equipment_id][item.name] = {v:'-',isArrow:null,}
          }else{
            this.ws_v[item.equipment_id] = {}
            this.ws_v[item.equipment_id][item.name] = {v:'-',isArrow:null,}
          } 


          if (item.is_show && count < 3 && item.name == "透平机转速") { // 判断是否满足条件且未超过两个
            this.currentSelect.push(`${item.root_sn}-${item.id}`);
            count++; // 计数加1
          }
          column.push(item.key)
          let obj = {
              name: item.equip_name + "-" + item.name,
              measurement_name: item.name,
              root_sn: item.root_sn,
              key: item.key,
              ids: this.equip_data.id,
              equipment_id:item.equipment_id,
              measurement_id:item.id,
              unit: item.unit,
              data: [],
              type: "line",
              dtype:item.dtype,
              showSymbol: false,
              is_checked: false,
              lineStyle: {
                //设置线条默认样式
                normal: {
                  width: 1,
                },
                //设置线条hover样式
                emphasis: {
                  // 鼠标hover上去的时候，拐点的颜色和样式
                  itemStyle: {
                    color: "#fff", //颜色
                    borderColor: "#0072FF", //图形的描边颜色
                    borderWidth: 3, // 描边的线宽
                    shadowBlur: 1, // 图形的阴影大小
                    shadowColor: "#0072FF", // 图形的阴影颜色
                  },
                },
              },
              markPoint: {
                data: [],
              },
              markLine: {
                data: [],
              },
            }
            if(this.currentSelect.includes(`${item.root_sn}-${item.id}`)){
              obj.is_checked = true
            }
          this.leftMeasurementsList.push(obj)
        })

        this.default_checked_keys = this.currentSelect
        
        this.$nextTick(()=>{
          let allRequests = [];
          for (let key in this.measurementsGroup) {
            this.shadowIdList.push(key)
            if (this.measurementsGroup[key].length) {
              let measurement_key = []
              this.measurementsGroup[key].map(item =>{
                if (this.currentSelect.includes(`${item.root_sn}-${item.id}`)) {
                  measurement_key.push(item.key)
                }
              });
              
              let paramsdata = {
                start: '10m',
                end: '0m',
                limit: 14,
                measurement_key,
              };
              let params = qs.stringify(paramsdata, { arrayFormat: "repeat" });

              // 将请求添加到 allRequests 数组中
              allRequests.push({
                request: getRawTimeseries(key, params).then(ress => ({
                  key,
                  data: ress
                })),
                key: key,
              });                
            }
          }

          // 等待所有请求完成后处理数据
          Promise.all(allRequests)
            .then(async results => {

              // results 是一个数组，包含所有请求的返回结果
              // 在此进行数据汇总和过滤
              let allData = results.map(async result => {
                const resp = await result.request;
                if(resp.data.payload.length){
                  this.timestamp = moment(resp.data.timestamp).format("YYYY.MM.DD HH:mm")
                }
                return { data:resp.data.payload, key: resp.key}
              } )
              
              // 可以根据你的需求对 allData 进行过滤操作
              
              // 动态合并每个索引位置的对象
              const mergedData = await Promise.all(allData);
              
              mergedData.map((item, index) => {
                
                this.leftMeasurementsList.map((s, i) => {
                  s.yAxisIndex = i;
                  if (item.key == s.equipment_id) { 
                    item.data.map(i=>{
                      if (i[s.key] != null) {
                        s.data.push({
                          name: moment(i.ts)
                            .format("YYYY-MM-DD HH:mm:ss.SSS")
                            .valueOf(),
                          value: [
                            moment(i.ts)
                              .format("YYYY-MM-DD HH:mm:ss.SSS")
                              .valueOf(),
                              formatNumber(i[s.key]),
                              s.equipment_id,
                          ],
                        });
                      }
                    })
                    
                    if(s.data&&s.data[s.data.length-1]){
                      if (this.ws_v[s.equipment_id]) {
                        this.ws_v[s.equipment_id][s.measurement_name].v = s.data[s.data.length-1].value[1]
                      }
                    }
                  }
                });
              });

              this.measurementsList.forEach(item=>{
                  item.list.forEach(i=>{
                    
                    if(this.ws_v[item.equip_id] &&this.ws_v[item.equip_id][i.full_name]){
                      i.value = this.ws_v[item.equip_id][i.full_name].v
                      i.isArrow = this.ws_v[item.equip_id][i.full_name].isArrow
                    }

                  })
                })

            }).finally(() => {
              
              this.$nextTick(() => {

                this.updateChart(this.leftMeasurementsList,false) //初始化echarts
              });
              this.myChart && this.myChart.hideLoading();
            })
        })
      },
      /**
       * 
       * @param dataLists series数据
       * @param falg 只更新series数据
       */
      updateChart(dataLists,falg){
        const data = _.cloneDeep(dataLists)
        data.map((item,index)=>{
          let yData = []
          if(item.is_checked){
            item.data.map(i=>{
              yData.push(i.value[1])
            })
          }
          item.yData = yData
        })
        spectrumEcharts4({
          chartDom: document.getElementById("miniEcharts"),
          dataLists:data,
          equip_data:this.equip_data
        },falg);
      },
      initWebSocket(){
        const interval = setInterval(() => {
          if (this.retryCount > 10) {
            clearInterval(interval)
            this.retryCount = 0
            return
          }
          const stompClient = this.$websocket.getters.stompClient()
          if (stompClient != null && stompClient.connected) {
            clearInterval(interval)
            stompClient.subscribe("/topic/stream", msg => {
              if (msg && msg.body) {
                let websocketdata = Array.isArray(JSON.parse(msg.body)) ? JSON.parse(msg.body) : [JSON.parse(msg.body)];
                /* 避免其他页面触发 */ 
                  if (this.$route.path == "/VSD420-OverAll") {   
                    /*  获取推送数据,处理 */ 
                    this.getWebsocket(websocketdata)
                  }
              }
            })
          } else {
            if (!sessionStorage.getItem("accessToken")) return
            const _url = SOCKET_SVC_HOST + "/messaging/stomp?access_token=" + sessionStorage.getItem("accessToken");
            this.$websocket.dispatch('WEBSOCKET_INIT', _url)
          }
          this.retryCount++
        }, 1000)
      },
      // 获取推送数据,处理
      getWebsocket(socdata) {
        if ( socdata && socdata.length ) {
          socdata.map((soc) => {
            /* 匹配推送的对应设备的id */ 

            if(this.shadowIdList.includes(soc.shadowId)&&soc.report.length){
              for(let item of soc.report){
              /* 复制对应测点值 */
              let _index = this.leftMeasurementsList.findIndex(i => i.equipment_id == soc.shadowId && i.key === item.id)
              if(_index >-1){
                  const value = formatNumber(item.v)
                  if (this.leftMeasurementsList[_index].data.length == 14) {
                    this.leftMeasurementsList[_index].data.shift()
                  }
                  this.leftMeasurementsList[_index].data.push({
                    name: moment().format("YYYY-MM-DD HH:mm:ss.SSS").valueOf(),
                    value: [ moment().format("YYYY-MM-DD HH:mm:ss.SSS").valueOf(), value, soc.shadowId ],
                  })
                  const name = this.isCurrentORDefault(soc.shadowId,item.id) 
                  //只更新的数据做修改
                  if(this.ws_v[soc.shadowId] && this.ws_v[soc.shadowId][name]){
                    this.ws_v[soc.shadowId][name].v = value
                  }
              }
            }

            this.timestamp = moment().format("YYYY.MM.DD HH:mm")
            this.measurementsList.forEach(item=>{
              item.list.forEach(i=>{
                if(this.ws_v[item.equip_id] &&this.ws_v[item.equip_id][i.full_name]){

                  i.value = this.ws_v[item.equip_id][i.full_name].v
                  i.isArrow = this.ws_v[item.equip_id][i.full_name].isArrow
                }
              })
            })
            this.$nextTick(()=>{
              this.updateChart(this.leftMeasurementsList,true) // 只更新series数据
            })
            }
          });
        }
      },
      /**
       * 是否属于不同设备下同名的电流名称
       * @param id 设备id下的电流对应的电流名称
       * @param name 用于不是电流的名称
       */
      isCurrentORDefault(id,key){
        let reslut = ''
        if(this.measurementsGroup[id]){
          this.measurementsGroup[id].forEach(item=>{
            if(item.key == key){
              reslut = item.name
              return;
            }
          })
        }
        return reslut;
      } 
    },
    components:{
      Close,
      SelectsTop,
    },
  }
  </script>
  
  <style lang="scss">
  .paper-dialog{
    .el-dialog__header{
      padding-bottom: 0 !important;
    }
  }
  /* 弹框层级 */ 
  .el-overlay{
    z-index: 2010 !important;
  }
  .el-dialog{
    background-color: #12243B !important;
    color: #fff !important;
  }
  .my-header {
    padding-bottom: 10px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 16px;
    border-bottom:1.5px solid rgba(198, 194, 194, 0.2);
  }
  .paper-dialog{
    .outside-center{
      margin: 15px;
      color: #fff;
      font-size: 16px;
    }
    // 卡片样式
    .part-card{
      width: inherit;
      margin: 10px;
      padding: 21px 15px;
      display: flex;
      flex-flow: column;
      border: 1px solid #C6C2C233;
      border-radius: 20px;
      position: relative;
    }
    // 按钮样式
    .status-button{
      margin-top: 18px;
      width: 200px;
      height: 110px;
      background-size: cover;
    }
    /* 标题字号大小 */ 
    .top_name {
      font-size: 16px !important;
    }
    // model logs样式
    .date-box-item-p{
      min-width: 72.09px;
      padding: 0 5px;
      line-height: 22px;
      text-align: center;
      letter-spacing: 1px; //字间距
      font-size: 10px;
      border-radius: 4px;
      background: linear-gradient(90deg, #01ABB7 0%, #01628C 100%);
    }
    .running-icon-p{
      width:35px;
      height:35px;
      top:74px;
      right:105px;
    }
    .true-icon-p{
      width:21px;
      height:21px;
      top:50px;
      right:79px;
    }

    // 组态图测点样式
    .meas-table{
      font-family: Noto Sans SC;
      font-size: 12px;
      font-weight: 400;
      td{
        padding: 3px 0px;
      }
      tr{
        background: rgba(73, 87, 105, 0.8);
      }
      tr:nth-child(2n){
        background: rgba(34,51,72,0.8);
      }
    }

  }

  /** running状态闪烁 */ 
  @keyframes animated-border {
    0% {
      box-shadow: 0 0 0 0 rgba(86,164,244,0.5);
    }
    100% {
      box-shadow: 0 0 0 20px rgba(108,146,230,0);
    }
  }
  .outerAnimation {
    border-radius: 10px;
    animation: animated-border 1.5s infinite;
  }


  /**测点文字闪烁*/
  .blink{ 
    color:#01ABB7; 
    animation: animated-borders 0.5s  ease-in  infinite ;
    /* 其它浏览器兼容性前缀 */
    -webkit-animation: animated-borders 0.5s linear infinite;
    -moz-animation: animated-borders 0.5s linear infinite;
    -ms-animation: animated-borders 0.5s linear infinite;
    -o-animation: animated-borders 0.5s linear infinite;
  }  

  @keyframes animated-borders {
    0% {
      box-shadow: 0 0 0 0 rgba(1,171,183,0.5);
    }
    100% {
      box-shadow: 0 0 0 20px rgba(1,171,183,0);
    }
  }

</style>
